'use client';

import { getCrmPointsRules } from '@/api/public';
import Button from '@/components/Button';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { PointFilled } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

const YourPoints = ({
  memberPrivileges,
  handleLogin,
  handleJoinNow,
}: {
  memberPrivileges: any;
  handleLogin?: () => void;
  handleJoinNow: () => void;
}) => {
  const t = useTranslations('zeeloolRewards.earnRedeemSection');
  const token = useStore((state) => state.token);
  logger.log(memberPrivileges, '@@memberPrivileges');

  const [crmPointRule, setCrmPointRule] = useState<any>({});
  const [yourPointsData, setYourPointsData] = useState<any>({
    title: t('title'),
    description: t('description'),
    points_info: {
      title: t('yourPointsTitle'),
      purchase_desc: t('purchaseDescription', {
        ratio: crmPointRule?.deduct?.ratio || 1,
        dollar: crmPointRule?.deduct?.dollar || 10,
      }),
      redeem_desc: t('redeemDescription', {
        ratio: crmPointRule?.deduct?.integral_product_ratio || 10,
        dollar: crmPointRule?.deduct?.dollar || 1,
      }),
      icon: '/account/zeelool-rewards/icon-points.png', // Assuming icon path
    },
    join_now_text: t('joinNowText'),
    login_text: t('loginText'),
    login_href: t('loginHref'),
  });

  const getCrmPointRuleAction = async () => {
    const { code, data } = await getCrmPointsRules();
    if (code === 200) {
      setCrmPointRule(data);
      setYourPointsData({
        ...yourPointsData,
        points_info: {
          ...yourPointsData.points_info,
          purchase_desc: t('purchaseDescription', {
            ratio: data?.deduct?.ratio,
            dollar: data?.deduct?.dollar,
          }),
          redeem_desc: t('redeemDescription', {
            ratio: data?.deduct?.integral_product_ratio,
            dollar: data?.deduct?.dollar,
          }),
        },
      });
    }
  };

  useEffect(() => {
    getCrmPointRuleAction();
  }, []);

  return (
    <>
      <WebOnly>
        <div className="bg-white pt-[104px] text-center">
          <div className="mx-auto max-w-[1200px]">
            <h2 className="text-[32px] font-bb">{yourPointsData.title}</h2>
            <p className="mt-12 text-sm text-[#808080] font-br">{yourPointsData.description}</p>
            <div className="mx-auto flex max-w-[600px] flex-col items-center rounded-lg bg-[#f5f5f5] py-30 mt-[32px]">
              <div className="mb-5 flex items-center">
                <h3 className="flex items-center gap-2 text-2xl font-bb">
                  <PointFilled />
                  <span className="text-[28px] font-bb">{yourPointsData.points_info.title}</span>
                </h3>
              </div>
              <p className="text-[14px] leading-normal text-[#808080] mt-18">
                {yourPointsData.points_info.purchase_desc}
                <br />
                {yourPointsData.points_info.redeem_desc}
              </p>
            </div>
            <div className="mt-[30px] flex flex-col items-center">
              <Button
                variant="contained"
                color="black"
                radiusSize="large"
                className="w-[240px] h-[40px] rounded-20 !bg-[#282828] text-white !text-14"
                onClick={() => handleJoinNow()}
              >
                {yourPointsData.join_now_text}
              </Button>

              {!token && (
                <span className="mt-16 text-sm text-[#808080] flex items-center">
                  {yourPointsData.login_text}
                  <span
                    className="text-[#808080] underline cursor-pointer"
                    onClick={() => handleLogin()}
                  >
                    {yourPointsData.login_href}
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="bg-white px-14 pt-[52px] text-center">
          <div className="mx-auto">
            <h2 className="text-[24px] leading-[29px] font-bb">{yourPointsData.title}</h2>
            <p className="mt-8 text-[13px] leading-[16px] text-[#808080] font-br">
              {yourPointsData.description}
            </p>
            <div className="mx-auto flex flex-col items-center rounded-lg bg-[#f4f4f4] pt-24 pb-16 mt-[20px]">
              <div>
                <h3 className="flex items-center">
                  <PointFilled className="text-[32px] mr-8" />
                  <span className="text-[24px] leading-[29px] font-bb">
                    {yourPointsData.points_info.title}
                  </span>
                </h3>
              </div>
              <p className="text-[13px] leading-[19px] text-[#808080] mt-12">
                {yourPointsData.points_info.purchase_desc}
                <br />
                {yourPointsData.points_info.redeem_desc}
              </p>
            </div>
            <div className="mt-[20px] flex flex-col items-center">
              <Button
                onClick={() => handleJoinNow()}
                className="w-[240px] h-[36px] rounded-[22px] !bg-[#282828] text-[14px] font-bb !text-white"
              >
                {yourPointsData.join_now_text}
              </Button>

              {!token && (
                <span className="mt-20 text-[12px] flex items-center">
                  {yourPointsData.login_text}&nbsp;
                  <span className="underline cursor-pointer" onClick={() => handleLogin()}>
                    {yourPointsData.login_href}
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>
      </WapOnly>
    </>
  );
};

export default YourPoints;
